var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandNotificationService24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "incon_notification_service24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_notifications24x24",
    transform: "translate(-1 -1.006)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M9.336,6.272,8.281,5.1A8.208,8.208,0,0,0,5,11.194H6.524A6.327,6.327,0,0,1,9.336,6.272Z",
    transform: "translate(0 .017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M18.1,11.194h1.524A8.063,8.063,0,0,0,16.455,5.1L15.4,6.155a7.221,7.221,0,0,1,2.7,5.039Z",
    transform: "translate(1.381 .017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M17.645,11.887A5.136,5.136,0,0,0,13.9,6.812v-.6a1.138,1.138,0,1,0-2.272,0v.6A5.014,5.014,0,0,0,7.88,11.886v4.47L6.4,17.928v.846H19.236v-.846l-1.477-1.571Z",
    transform: "translate(.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M12.241,18.524h.352a1.43,1.43,0,0,0,1.055-.938A1.057,1.057,0,0,0,13.764,17H10.6a1.75,1.75,0,0,0,1.641,1.524Z",
    transform: "translate(.761 2.476)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12074",
    "data-name": "Rectangle 12074",
    width: 24,
    height: 24,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandNotificationService24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brand_notification_service24x24.17e9e9cfe892039370139cdcc62f53b6.svg";